import { useJobItemTemplates } from '@/api/Jobs';
import { JobItemTemplate } from '@/types';
import { CustomColumns, CustomTable } from '@/ui/components/CustomTable';
import { Card } from 'antd';
import React, { FC, useMemo } from 'react';

export const JobItemTemplatesDataGrid: FC<{
  jobTemplateId: number;
}> = ({ jobTemplateId }) => {
  const { data: jobItemTemplates, isFetching: isJobItemTemplatesLoading } =
    useJobItemTemplates(jobTemplateId);

  const columns: CustomColumns<JobItemTemplate> = useMemo(
    () => [
      {
        dataIndex: 'name',
        title: 'Name',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        dataIndex: 'description',
        title: 'Description',
        sortable: true,
        filter: true,
        width: 250,
      },
      {
        dataIndex: 'orderSequence',
        title: 'Order Sequence',
        sortable: true,
        filter: true,
        width: 150,
        align: 'center',
      },
    ],
    [],
  );

  return (
    <Card>
      <CustomTable
        dataSource={jobItemTemplates || []}
        columns={columns}
        rowKey="jobItemTemplateId"
        loading={isJobItemTemplatesLoading}
        pagination={false}
      />
    </Card>
  );
};
